import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function Submit() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    loanId,
    loanDescription,
    dueDate,
    maturityDate,
    paymentAmount,
    futureDueDate,
    futureMaturityDate,
    ltloc,
    accountDetails = []
  } = location.state || {};

  useEffect(() => {
    document.title = 'Skip a Pay | MAX Credit Union';
  }, []);

  const [isCollapsed, setIsCollapsed] = useState(false);


  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!loanId || !loanDescription) {
      navigate('/');
    }
  }, [loanId, loanDescription, navigate]);

  if (!loanId || !loanDescription) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {isCollapsed && <TopMenu />}
      <div style={{ display: 'flex', flex: 1 }}>
        <SideMenu menuItems={menuItems} />
        
        <div style={{ flex: 1, padding: '20px 20px 20px 260px', overflow: 'auto' }}>
          <style type="text/css">
            {`
              .btnwrapper {padding: 20px;}
              .ctr {text-align: center;}
              q2-btn {width: 40%;}
              body {}
              p {font-size: medium; font-weight: normal;}
              h1, h2, h3, h4, h5, h6 {font-size: large; font-weight: bold; color: #3b8ede;}

              .select-container {
                  display: flex;
                  gap: 10px;
              }

              .custom-select {
                  width: 50%; /* Takes up half of the page width */
              }

              /* Responsive image style */
              img {
                  max-width: 100%;
                  height: auto;
                  display: block;
                  margin: 0 auto;
              }

              @media screen and (max-width: 768px) {
                div[style*="padding: 20px 20px 20px 260px"] {
                  padding: 20px 20px 20px 60px !important;
                }
              }
            `}
          </style>

          <img src="/SkipAPayHeaders-3.png" alt="Banner Image" />

          <div>
            <span>
              <br />Congratulations! You have successfully skipped your next payment.
              <p>Your new loan terms are listed below.</p>
              <p>Loan ID: {loanId}</p>
              <p>Loan Description: {loanDescription}</p>
              <p>Payment Amount: ${paymentAmount}</p>
              <p>Payment Due Date: {dueDate}</p>
              <p>Maturity Date: {maturityDate}</p>
              <p>Future Due Date: {futureDueDate}</p>
              <p>Future Maturity Date: {futureMaturityDate}</p>
              <p>Account Details: {accountDetails.join(' ')}</p>
              <p>Attention Auto Payment Users! If you have automatic payments set up outside of MAX, please remember to pause them for the month you have chosen to skip.</p>
            </span>
          </div>


          <input type="hidden" id="routing_key" name="routing_key" value="submit" />
          <input type="hidden" id="selected" name="selected" value={`${loanId}:${loanDescription}:${dueDate}:${maturityDate}:${paymentAmount}:${futureDueDate}:${futureMaturityDate}:${ltloc}`} />
          <input type="hidden" id="payment" name="payment" value={accountDetails.join(':')} />
          <div>
           
          </div>
        </div>
      </div>
    </div>
  );
}

export default Submit;